import { styled, Box } from '@mui/system';
import { Link, Paper, Typography } from '@mui/material';
import BG from '../../../assets/images/AuthBack.svg';
import BG_RESPONSIVE from '../../../assets/images/BG_RESP.png';

export const StyledAuth = styled(Paper)(({ theme }) => ({
  gridColumnStart: '2',
  marginTop: '4rem',
  marginBottom: '2rem',
  background: 'white',
  borderRadius: '12px',
  paddingBottom: '4rem',
  boxShadow: '0px 40px 40px 40px rgba(0, 0, 0, 0.12)',
  minWidth: '510px',
  minHeight: '590px',
  '.form-container': {
    width: '320px',
    marginTop: '4rem'
  },
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down(1025)]: {
    gridColumnStart: '1',
    maxWidth: '80%',
    width: '80%',
    minWidth: '280px',
    minHeight: '340px',
    '.form-container': {
      maxWidth: '80%',
      minWidth: '80%'
    },
  }
}));

export const AuthContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gridTemplateRows: '1fr',
  justifyContent: 'center',
  alignContent: 'center',
  justifyItems: 'center',
  alignItems: 'center',
  backgroundImage: `url(${BG})`,
  backgroundAttachment: 'fixed',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  minHeight: '100vh',
  [theme.breakpoints.down(1025)]: {
    gridTemplateColumns: '1fr',
    position: 'static',
    minHeight: '100vh',
    backgroundImage: `url(${BG_RESPONSIVE})`
  }
}));

export const AuthTitle = styled(Typography)(() => ({
  marginBottom: '1rem',
  fontSize: '32px',
  lineHeight: '37px'
}));

export const AuthSubtitle = styled(Typography)(({ theme }) => {
  return {
    marginBottom: '2rem',
    color: theme.palette.claraPalette.gray1,
    fontSize: '14px',
    lineHeight: '16px',
    display: 'inline-block',
    '.em': {
      color: theme.palette.primary.main
    }
  };
});

export const ExternalLinkInline = styled(Link)(() => ({
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline'
  },
  display: 'inline-block'
}));